import { CONSTANTS } from '../../theme/constants';
import { Get, Put } from './authorizedRequest';

const endpoint = '/' + CONSTANTS.PORT_LOCODE + '/containers/';

export async function getSubscriptions(obj) {
  const request = await Get(endpoint + 'import/subscriptions', obj);
  const response = await fetch(request);
  if (!response.ok) {
    let err;
    try {
      err = await response.json();
    } catch {
      throw new Error(response.statusText);
    }
    throw err;
  }
  return response;
}

export async function putSubscription(obj) {
  const request = await Put(endpoint + obj.equipmentNumber + '/import/subscription', obj);
  const response = await fetch(request);

  if (!response.ok) {
    let err;
    try {
      err = await response.json();
    } catch {
      throw new Error(response.statusText);
    }
    throw err;
  }

  let responseJson = response.json();

  return responseJson;
}
